import { render } from "./DataTable.vue?vue&type=template&id=51c8231a&scoped=true"
import script from "./DataTable.vue?vue&type=script&lang=js"
export * from "./DataTable.vue?vue&type=script&lang=js"

import "./DataTable.vue?vue&type=style&index=0&id=51c8231a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51c8231a"],['__file',"src/views/HistoricalData/UpgradeRecords/components/DataTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "51c8231a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('51c8231a', __exports__)) {
    api.reload('51c8231a', __exports__)
  }
  
  module.hot.accept("./DataTable.vue?vue&type=template&id=51c8231a&scoped=true", () => {
    api.rerender('51c8231a', render)
  })

}


export default __exports__